module.exports = __webpack_public_path__ + "static/media/arrow_login.6e874aea.svg";